export default __webpack_public_path__ + "static/media/about_read.2f89c544.png";